import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

/**
 * Generated class for the DynamicInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "dynamic-input",
  templateUrl: "dynamic-input.html",
})
export class DynamicInputComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() formGroup: FormGroup;

  internalConfig: object;

  constructor() {}

  ngOnInit(): void {}

  @Input() set config(config: object) {
    // console.log( "Receiving configuration for input: ", config );
    if (config === undefined) {
      console.error(
        "Configuration not loaded for input! Check template for mismatched layout and input ids."
      );
    } else {
      this.internalConfig = config;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/dynamic-input/dynamic-input.ts